(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iron-new-arrivals"] && !Shopify.designMode) return;
  try {
    
(function(){
  function openCartDrawer() {
    // Refresh cart sections via Shopify Sections API, then open drawer
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        // Update cart icon bubble (count badge)
        if (sections['cart-icon-bubble']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = sections['cart-icon-bubble'];
          var freshBubble = tmp.querySelector('#cart-icon-bubble');
          var existBubble = document.querySelector('#cart-icon-bubble');
          if (freshBubble && existBubble) existBubble.innerHTML = freshBubble.innerHTML;
        }
        // Update cart drawer inner content
        if (sections['cart-drawer']) {
          var tmp2 = document.createElement('div');
          tmp2.innerHTML = sections['cart-drawer'];
          var freshDrawer = tmp2.querySelector('#CartDrawer');
          var existDrawer = document.querySelector('#CartDrawer');
          if (freshDrawer && existDrawer) existDrawer.innerHTML = freshDrawer.innerHTML;
        }
      })
      .catch(function() {})
      .finally(function() {
        // Open the cart drawer after content is refreshed
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') {
          drawer.open();
        } else {
          // Fallback: click cart icon button
          var cartBtn = document.querySelector('#cart-icon-bubble, [aria-controls="CartDrawer"], .header__icon--cart');
          if (cartBtn) cartBtn.click();
        }
      });
  }

  function handleAddToCart(btn) {
    var id = btn.dataset.variantId;
    if (!id || btn.classList.contains('is-adding')) return;
    btn.classList.add('is-adding');
    btn.textContent = 'ADDING...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
    })
    .then(function(r) {
      if (!r.ok) return r.json().then(function(d) { throw new Error(d.description || 'Error'); });
      return r.json();
    })
    .then(function() {
      btn.classList.remove('is-adding');
      btn.classList.add('is-added');
      btn.textContent = '✓ ADDED';
      openCartDrawer();
      setTimeout(function() {
        btn.classList.remove('is-added');
        btn.textContent = 'ADD TO CART';
      }, 2200);
    })
    .catch(function(err) {
      btn.classList.remove('is-adding');
      btn.textContent = err.message || 'TRY AGAIN';
      setTimeout(function() { btn.textContent = 'ADD TO CART'; }, 2000);
    });
  }

  // Mobile slider prev/next
  document.querySelectorAll('.ina-slider-wrap').forEach(function(wrap) {
    var grid = wrap.querySelector('.ina-grid');
    var prev = wrap.querySelector('.ina-nav--prev');
    var next = wrap.querySelector('.ina-nav--next');
    if (!grid || !prev || !next) return;

    function updateNav() {
      var atStart = grid.scrollLeft <= 4;
      var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 4;
      prev.classList.toggle('ina-nav--hidden', atStart);
      next.classList.toggle('ina-nav--hidden', atEnd);
    }

    function scrollBy(dir) {
      var card = grid.querySelector('.ina-card');
      var step = card ? card.offsetWidth + 12 : grid.clientWidth * 0.8;
      grid.scrollBy({ left: dir * step, behavior: 'smooth' });
    }

    prev.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); scrollBy(-1); });
    next.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); scrollBy(1); });
    grid.addEventListener('scroll', updateNav, { passive: true });
    updateNav();
  });

  // Event delegation — works regardless of when DOM loads
  document.addEventListener('click', function(e) {
    var cartBtn = e.target.closest('.ina-overlay-btn--cart');
    if (cartBtn) {
      e.preventDefault();
      e.stopPropagation();
      handleAddToCart(cartBtn);
      return;
    }
    var quickBtn = e.target.closest('.ina-overlay-btn--quick');
    if (quickBtn) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = quickBtn.dataset.url;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iron-product"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-iron-pdp]').forEach(function(root){
    var stage = root.querySelector('[data-stage]');
    var slides = Array.from(root.querySelectorAll('[data-slide]'));
    var thumbs = root.querySelectorAll('[data-thumb]');
    var dots   = root.querySelectorAll('[data-dot]');
    var counter = root.querySelector('[data-counter]');
    var total = slides.length;
    var curIdx = 0;

    function show(i){
      curIdx = ((i % total) + total) % total;
      slides.forEach(function(s,n){ s.classList.toggle('is-active', n===curIdx); });
      thumbs.forEach(function(t,n){ t.classList.toggle('is-active', n===curIdx); });
      dots.forEach(function(d,n){ d.classList.toggle('is-active', n===curIdx); });
      if(counter) counter.textContent = (curIdx+1)+' / '+total;
      stage.classList.remove('is-zoom');
      if(lb && !lb.hidden) renderLb();
    }

    root.querySelectorAll('[data-prev]').forEach(function(b){ b.addEventListener('click', function(){ show(curIdx-1); }); });
    root.querySelectorAll('[data-next]').forEach(function(b){ b.addEventListener('click', function(){ show(curIdx+1); }); });
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ show(+t.dataset.index); }); });
    dots.forEach(function(d){ d.addEventListener('click', function(){ show(+d.dataset.index); }); });

    stage.addEventListener('mousemove', function(e){
      var img = slides[curIdx].querySelector('[data-zoomable]'); if(!img) return;
      var r = stage.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX-r.left)/r.width*100)+'% '+((e.clientY-r.top)/r.height*100)+'%';
    });
    stage.addEventListener('click', function(e){
      if(e.target.closest('button')) return;
      if(!slides[curIdx].querySelector('[data-zoomable]')) return;
      stage.classList.toggle('is-zoom');
    });

    var sx=null;
    stage.addEventListener('touchstart',function(e){ sx=e.touches[0].clientX; },{passive:true});
    stage.addEventListener('touchend',function(e){
      if(sx===null) return; var d=e.changedTouches[0].clientX-sx;
      if(d<-45) show(curIdx+1); else if(d>45) show(curIdx-1); sx=null;
    });

    // Lightbox
    var lb = root.querySelector('[data-lightbox]');
    var lbStage = root.querySelector('[data-lb-stage]');
    var lbCounter = root.querySelector('[data-lb-counter]');
    function renderLb(){
      var node = slides[curIdx].cloneNode(true);
      lbStage.innerHTML=''; while(node.firstChild) lbStage.appendChild(node.firstChild);
      if(lbCounter) lbCounter.textContent=(curIdx+1)+' / '+total;
    }
    var lbOpen = root.querySelector('[data-lightbox-open]');
    if(lbOpen) lbOpen.addEventListener('click',function(){ lb.hidden=false; renderLb(); document.body.style.overflow='hidden'; });
    root.querySelector('[data-lightbox-close]').addEventListener('click',function(){ lb.hidden=true; document.body.style.overflow=''; });
    document.addEventListener('keydown',function(e){
      if(lb.hidden) return;
      if(e.key==='Escape'){ lb.hidden=true; document.body.style.overflow=''; }
      if(e.key==='ArrowRight') show(curIdx+1);
      if(e.key==='ArrowLeft') show(curIdx-1);
    });

    // Quantity stepper
    var qty = 1;
    var qtyDisplay = root.querySelector('[data-qty-display]');
    var stickyQtyDisplay = root.querySelector('[data-sticky-qty-display]');
    function updateQty(n){
      qty = Math.max(1, Math.min(99, n));
      if(qtyDisplay) qtyDisplay.textContent = qty;
      if(stickyQtyDisplay) stickyQtyDisplay.textContent = qty;
      var hiddenQty = root.querySelector('input[name="quantity"]');
      if(hiddenQty) hiddenQty.value = qty;
    }
    var decBtn = root.querySelector('[data-qty-dec]');
    var incBtn = root.querySelector('[data-qty-inc]');
    if(decBtn) decBtn.addEventListener('click', function(){ updateQty(qty-1); });
    if(incBtn) incBtn.addEventListener('click', function(){ updateQty(qty+1); });

    // Add quantity input to form
    var form = root.querySelector('#iron-form');
    if(form){
      var qInput = document.createElement('input');
      qInput.type='hidden'; qInput.name='quantity'; qInput.value='1';
      form.appendChild(qInput);
    }

    // Variants
    var varData = root.querySelector('[data-iron-variants]');
    var variants = varData ? JSON.parse(varData.textContent) : [];
    var selected = {};
    root.querySelectorAll('[data-opt-value]').forEach(function(btn){
      if(btn.classList.contains('is-selected')) selected[btn.dataset.optPosition]=btn.dataset.value;
      btn.addEventListener('click',function(){
        var pos=btn.dataset.optPosition;
        root.querySelectorAll('[data-opt-value][data-opt-position="'+pos+'"]').forEach(function(b){ b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        selected[pos]=btn.dataset.value;
        var lbl=root.querySelector('[data-opt-current="'+(+pos-1)+'"]'); if(lbl) lbl.textContent=btn.dataset.value;
        syncVariant();
      });
    });
    function syncVariant(){
      var match=variants.find(function(v){ return v.options.every(function(o,i){ return o===selected[String(i+1)]; }); });
      if(!match) return;
      root.querySelector('[data-variant-id]').value=match.id;
      root.querySelectorAll('[data-price],[data-price-cta],[data-sticky-price]').forEach(function(el){ el.textContent=match.price; });
      var sOpts=root.querySelector('[data-sticky-opts]'); if(sOpts) sOpts.textContent=match.title;
      var addBtn=root.querySelector('[data-add]'); if(addBtn) addBtn.disabled=!match.available;
      if(match.mediaIndex!==null && match.mediaIndex>=0) show(match.mediaIndex);
      window.history.replaceState({},'','?variant='+match.id);
    }

    // Sticky add
    var stickyAdd = root.querySelector('[data-sticky-add]');
    if(stickyAdd) stickyAdd.addEventListener('click',function(){ root.querySelector('#iron-form [data-add]').click(); });
    var sDec = root.querySelector('[data-sticky-dec]');
    var sInc = root.querySelector('[data-sticky-inc]');
    if(sDec) sDec.addEventListener('click',function(){ updateQty(qty-1); });
    if(sInc) sInc.addEventListener('click',function(){ updateQty(qty+1); });

    // AJAX add-to-cart
    function ironAddToCart(){
      var opts={};
      root.querySelectorAll('[data-opt-value].is-selected').forEach(function(b){ opts[b.dataset.optPosition]=b.dataset.value; });
      var vMatch=variants.find(function(v){ return v.options.every(function(o,i){ return o===opts[String(i+1)]; }); });
      var vid=vMatch ? String(vMatch.id) : root.querySelector('[data-variant-id]').value;
      if(!vid) return;
      var addBtn=root.querySelector('[data-add]');
      if(addBtn){ addBtn.disabled=true; addBtn.textContent='Adding...'; }
      fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id:Number(vid),quantity:qty})
      })
        .then(function(r){ return r.json(); })
        .then(function(data){
          if(addBtn){ addBtn.disabled=false; addBtn.textContent='ADD TO CART'; }
          if(data.status) return;
          var drawer=document.querySelector('cart-drawer');
          if(!drawer) return;
          return fetch('/?sections=cart-drawer,cart-icon-bubble',{headers:{'Accept':'application/json'}})
            .then(function(r){ return r.json(); })
            .then(function(sections){
              /* 1. Replace cart drawer HTML */
              var html=sections['cart-drawer'];
              if(html){
                var div=document.createElement('div');
                div.innerHTML=html;
                var fresh=div.querySelector('#CartDrawer');
                var target=document.querySelector('#CartDrawer');
                if(fresh&&target) target.innerHTML=fresh.innerHTML;
              }
              /* 2. Update cart icon bubble count */
              var bHtml=sections['cart-icon-bubble'];
              if(bHtml){
                var bEl=document.querySelector('#cart-icon-bubble');
                if(bEl){var bd=document.createElement('div');bd.innerHTML=bHtml;var bf=bd.querySelector('#cart-icon-bubble');if(bf)bEl.innerHTML=bf.innerHTML;}
              }
              /* 3. Open drawer — remove stale is-empty first so CSS shows correctly */
              drawer.classList.remove('is-empty');
              drawer.classList.add('animate','active');
              document.body.classList.add('overflow-hidden');
            });
        })
        .catch(function(){ if(addBtn){ addBtn.disabled=false; addBtn.textContent='ADD TO CART'; } });
    }
    // Intercept via click on button (bypasses any form.submit() confusion) AND form submit as backup
    root.querySelectorAll('[data-add]').forEach(function(btn){
      btn.addEventListener('click',function(e){ e.preventDefault(); ironAddToCart(); });
    });
    if(form){ form.addEventListener('submit',function(e){ e.preventDefault(); }); }

    show(0);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-popup"]) return;
  try {
    
(function(){
  var STORAGE_KEY = 'iron_pm_v2';
  var THRESHOLD   = 0.55;
  var DELAY_MS    = 2000;

  var pm     = document.getElementById('iron-pm');
  var reopen = document.getElementById('iron-pm-reopen');
  if (!pm) return;

  var phScratch  = document.getElementById('iron-pm-ph-scratch');
  var phRevealed = document.getElementById('iron-pm-ph-revealed');
  var phEmail    = document.getElementById('iron-pm-ph-email');
  var phDone     = document.getElementById('iron-pm-ph-done');
  var headEl     = document.getElementById('iron-pm-head');
  var subEl      = document.getElementById('iron-pm-sub');
  var canvas     = document.getElementById('iron-pm-canvas');
  var emailInput = document.getElementById('iron-pm-emailinput');
  var errEl      = document.getElementById('iron-pm-err');
  var copyBtn    = document.getElementById('iron-pm-copy');
  var phase      = 'scratch';
  var ctx, dim, canvasReady = false;

  function setPhase(p){
    phase = p;
    phScratch.hidden  = (p !== 'scratch');
    phRevealed.hidden = (p !== 'revealed');
    phEmail.hidden    = (p !== 'email');
    phDone.hidden     = (p !== 'done');
    var heads = {
      scratch:  ['TRY YOUR LUCK',   'Scratch the card below to reveal your reward.'],
      revealed: ['TRY YOUR LUCK',   'Scratch the card below to reveal your reward.'],
      email:    ['TRY YOUR LUCK',   "You scored a mystery discount — claim it below."],
      done:     ['WELCOME TO IRON', 'Your mystery discount is unlocked.'],
    };
    if(headEl) headEl.textContent = heads[p][0];
    if(subEl)  subEl.textContent  = heads[p][1];
  }

  function openModal(){
    pm.hidden = false;
    if(reopen) reopen.hidden = true;
    document.body.style.overflow = 'hidden';
    if(phase === 'scratch' && !canvasReady) initCanvas();
  }
  function closeModal(){
    pm.hidden = true;
    if(reopen) reopen.hidden = false;
    document.body.style.overflow = '';
    try{ localStorage.setItem(STORAGE_KEY, JSON.stringify({ ts: Date.now(), phase: phase })); }catch(e){}
  }

  function initCanvas(){
    if(!canvas || canvasReady) return;
    canvasReady = true;
    var dpr = window.devicePixelRatio || 1;
    // Read actual rendered size from DOM (accounts for all CSS breakpoints)
    var rect = canvas.getBoundingClientRect();
    var w = Math.round(rect.width  || canvas.parentElement.offsetWidth);
    var h = Math.round(rect.height || canvas.parentElement.offsetHeight);
    canvas.width  = Math.round(w * dpr);
    canvas.height = Math.round(h * dpr);
    ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);

    // Base gold gradient — bright center, darker edges
    var g = ctx.createLinearGradient(0, 0, w, h);
    g.addColorStop(0,    '#b8821e');
    g.addColorStop(0.25, '#ddb040');
    g.addColorStop(0.5,  '#f5d45a');
    g.addColorStop(0.72, '#e2b43a');
    g.addColorStop(1,    '#c49228');
    ctx.fillStyle = g;
    ctx.fillRect(0, 0, w, h);

    // Radial specular highlight (upper-center shine)
    var rg = ctx.createRadialGradient(w*0.5, h*0.18, 0, w*0.5, h*0.55, w*0.72);
    rg.addColorStop(0,   'rgba(255,252,210,0.52)');
    rg.addColorStop(0.35,'rgba(255,238,160,0.22)');
    rg.addColorStop(0.7, 'rgba(200,160,40,0.06)');
    rg.addColorStop(1,   'rgba(0,0,0,0.18)');
    ctx.fillStyle = rg;
    ctx.fillRect(0, 0, w, h);

    // Foil texture — random micro-flecks
    ctx.save();
    for(var ti = 0; ti < 1200; ti++){
      var nx = Math.random() * w;
      var ny = Math.random() * h;
      var nl = Math.random() > 0.5;
      ctx.globalAlpha = Math.random() * 0.07;
      ctx.fillStyle = nl ? '#fffacc' : '#7a5500';
      ctx.fillRect(nx, ny, Math.random()*4+0.5, Math.random()*1.5+0.3);
    }
    ctx.restore();

    // Diagonal sheen bands (subtle)
    ctx.save();
    ctx.globalAlpha = 0.09;
    ctx.fillStyle = '#fff';
    for(var si = -h; si < w+h; si += 32){
      ctx.beginPath();
      ctx.moveTo(si, h); ctx.lineTo(si + h*0.65, 0);
      ctx.lineTo(si + h*0.65 + 10, 0); ctx.lineTo(si + 10, h);
      ctx.closePath(); ctx.fill();
    }
    ctx.restore();

    // Edge vignette
    var vg = ctx.createLinearGradient(0, 0, 0, h);
    vg.addColorStop(0,   'rgba(0,0,0,0.12)');
    vg.addColorStop(0.15,'rgba(0,0,0,0)');
    vg.addColorStop(0.85,'rgba(0,0,0,0)');
    vg.addColorStop(1,   'rgba(0,0,0,0.18)');
    ctx.fillStyle = vg;
    ctx.fillRect(0, 0, w, h);

    // "SCRATCH HERE" text
    var fs = w < 300 ? 17 : (w < 380 ? 21 : 27);
    ctx.font = '700 ' + fs + 'px "Bebas Neue",sans-serif';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    // Shadow
    ctx.fillStyle = 'rgba(0,0,0,0.35)';
    ctx.shadowColor = 'rgba(0,0,0,0.4)';
    ctx.shadowBlur = 8;
    ctx.fillText('SCRATCH HERE', w/2 + 1, h/2 + 2);
    ctx.shadowBlur = 0;
    // Main text
    ctx.fillStyle = 'rgba(255,255,255,0.82)';
    ctx.fillText('SCRATCH HERE', w/2, h/2);

    dim = {w:w, h:h, dpr:dpr, r: Math.round(Math.max(w,h) * 0.065)};

    var down = false;
    function pt(e){
      var r  = canvas.getBoundingClientRect();
      var cx = e.touches ? e.touches[0].clientX : e.clientX;
      var cy = e.touches ? e.touches[0].clientY : e.clientY;
      return {x:(cx-r.left)*(w/r.width), y:(cy-r.top)*(h/r.height)};
    }
    function scratch(p){
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.arc(p.x, p.y, dim ? dim.r : 22, 0, Math.PI*2);
      ctx.fill();
      ctx.globalCompositeOperation = 'source-over';
    }
    function checkProgress(){
      if(phase !== 'scratch') return;
      var img   = ctx.getImageData(0,0,Math.round(dim.w*dim.dpr),Math.round(dim.h*dim.dpr)).data;
      var clear = 0, total = img.length/4;
      for(var i=3; i<img.length; i+=4*20){ if(img[i]<40) clear++; }
      if(clear/(total/20) > THRESHOLD){
        ctx.clearRect(0,0,Math.round(dim.w*dim.dpr),Math.round(dim.h*dim.dpr));
        setTimeout(function(){ setPhase('revealed'); }, 260);
      }
    }
    canvas.addEventListener('pointerdown',function(e){ down=true; scratch(pt(e)); e.preventDefault(); });
    canvas.addEventListener('pointermove',function(e){ if(!down) return; scratch(pt(e)); checkProgress(); e.preventDefault(); });
    window.addEventListener('pointerup',  function(){ down=false; });
    canvas.addEventListener('touchstart', function(e){ down=true; scratch(pt(e)); e.preventDefault(); },{passive:false});
    canvas.addEventListener('touchmove',  function(e){ if(!down) return; scratch(pt(e)); checkProgress(); e.preventDefault(); },{passive:false});
  }

  // Buttons
  document.getElementById('iron-pm-close').addEventListener('click', closeModal);
  if(reopen) reopen.addEventListener('click', function(){
    var savedPhase = 'scratch';
    try{
      var raw = localStorage.getItem(STORAGE_KEY);
      if(raw){ var d = JSON.parse(raw); if(d && d.phase && d.phase !== 'scratch') savedPhase = d.phase; }
    }catch(e){}
    if(savedPhase === 'scratch') canvasReady = false;
    setPhase(savedPhase);
    openModal();
  });
  document.getElementById('iron-pm-claim').addEventListener('click', function(){ setPhase('email'); });
  document.getElementById('iron-pm-continue').addEventListener('click', function(){
    var val = emailInput ? emailInput.value.trim() : '';
    var ok  = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);
    if(!ok){
      if(errEl) errEl.hidden = false;
      if(emailInput) emailInput.classList.add('is-err');
      return;
    }
    if(errEl) errEl.hidden = true;
    if(emailInput) emailInput.classList.remove('is-err');
    setPhase('done');
  });
  if(emailInput){
    emailInput.addEventListener('input', function(){
      if(errEl) errEl.hidden = true;
      emailInput.classList.remove('is-err');
    });
  }
  document.getElementById('iron-pm-skip').addEventListener('click', closeModal);
  document.getElementById('iron-pm-shop').addEventListener('click', closeModal);
  if(copyBtn){
    copyBtn.addEventListener('click', function(){
      var codeEl = pm.querySelector('.iron-pm__code');
      try{ navigator.clipboard && navigator.clipboard.writeText(codeEl ? codeEl.textContent.trim() : 'IRON10'); }catch(e){}
      copyBtn.textContent = 'COPIED ✓';
      copyBtn.classList.add('is-copied');
      setTimeout(function(){ copyBtn.textContent='COPY'; copyBtn.classList.remove('is-copied'); }, 1600);
    });
  }
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !pm.hidden) closeModal(); });
  document.getElementById('iron-pm-scrim').addEventListener('click', function(e){ if(e.target===this) closeModal(); });

  // Auto-show
  var stored = null;
  try{ stored = localStorage.getItem(STORAGE_KEY); }catch(e){}
  var seenAgo = Infinity;
  if(stored){
    try{
      var _d = JSON.parse(stored);
      seenAgo = Date.now() - (_d.ts || parseInt(stored,10));
    }catch(e){ seenAgo = Date.now() - parseInt(stored,10); }
  }
  if(seenAgo > 7*24*60*60*1000){
    setTimeout(function(){ setPhase('scratch'); openModal(); }, DELAY_MS);
  } else {
    if(reopen) reopen.hidden = false;
  }
})();

  } catch(e) { console.error(e); }
})();
})();
